import { render, staticRenderFns } from "./menu-subitem-cmp.vue?vue&type=template&id=0b55c6c6&scoped=true"
import script from "./menu-subitem-cmp.vue?vue&type=script&lang=js"
export * from "./menu-subitem-cmp.vue?vue&type=script&lang=js"
import style0 from "./menu-subitem-cmp.vue?vue&type=style&index=0&id=0b55c6c6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b55c6c6",
  null
  
)

export default component.exports